import * as api from '../services/agentRoster';

export const ROSTER_LOADING       = 'ROSTER_LOADING';
export const ROSTER_LOAD          = 'ROSTER_LOAD';
export const ROSTER_ERROR         = 'ROSTER_ERROR';
export const ROSTER_AUDIT_LOAD    = 'ROSTER_AUDIT_LOAD';
export const ROSTER_AUDIT_CLEAR   = 'ROSTER_AUDIT_CLEAR';

const insurerFromState = (getState) => {
  const u = getState().user || {};
  return u.insurer || 'max';
};

export const loadRoster = (agentType) => async (dispatch, getState) => {
  const state   = getState();
  const insurer = insurerFromState(getState);
  const type    = agentType || state.agentRoster.agentType;

  dispatch({ type: ROSTER_LOADING });
  try {
    const data = await api.getRoster(insurer, type);
    dispatch({ type: ROSTER_LOAD, payload: { ...data, agentType: type, insurer } });
  } catch (err) {
    const msg = (err.response && err.response.data && err.response.data.message) || err.message;
    dispatch({ type: ROSTER_ERROR, payload: msg });
  }
};

export const promoteAgentToTc = (agentId, reason) => async (dispatch, getState) => {
  const insurer = insurerFromState(getState);
  try {
    const data = await api.promoteToTc(insurer, agentId, reason);
    const currentType = getState().agentRoster.agentType;
    dispatch(loadRoster(currentType));
    return { ok: true, agentName: data.message };
  } catch (err) {
    const resp = err.response && err.response.data;
    return {
      ok:      false,
      code:    resp && resp.code,
      message: (resp && resp.message) || err.message,
    };
  }
};

export const loadAudit = (agentId, limit) => async (dispatch, getState) => {
  const insurer = insurerFromState(getState);
  try {
    const data = await api.getAudit(insurer, agentId, limit);
    dispatch({
      type:    ROSTER_AUDIT_LOAD,
      payload: { agentId, audit: data.audit || [] },
    });
  } catch (err) {
    const msg = (err.response && err.response.data && err.response.data.message) || err.message;
    dispatch({ type: ROSTER_ERROR, payload: msg });
  }
};

export const clearAudit = () => ({ type: ROSTER_AUDIT_CLEAR });
